import { useTheme } from '@emotion/react'

import {
  EarnestMonoLogo,
  ClearScoreMonoLogo,
  ToggleMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'

import { EarnestLogo, ClearScoreLogo, ToggleLogo } from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `earnest`,
      logo: <EarnestMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <EarnestLogo />,
      logoName: `Earnest`,
    },
    {
      company: `clear-score`,
      logo: <ClearScoreMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <ClearScoreLogo />,
      logoName: `ClearScore`,
    },
    {
      company: `toggle`,
      logo: <ToggleMonoLogo color={theme.palette.twilio.gray[70]} />,
      logoActive: <ToggleLogo />,
      logoName: `Toggle`,
    },
  ]
}

export { testimonialData }
